import Button from '../components/common/Button';
import Card from '../components/common/Card';
import PageHero from '../components/layout/PageHero';

function NotFound() {
  return (
    <>
      <PageHero
        eyebrow="404"
        title="Page not found"
        description="The page you are looking for is not available on FactorStreet."
      />
      <section className="section page-content">
        <div className="container">
          <Card>
            <h2>Return to the main site</h2>
            <p>Use the homepage to continue exploring FactorStreet and its operational projects.</p>
            <Button to="/">Go Home</Button>
          </Card>
        </div>
      </section>
    </>
  );
}

export default NotFound;
